import React from "react";
import { /*  NavLink, */ useHistory } from "react-router-dom";
import { Typography, Button } from "@material-ui/core";
import HomeRoundedIcon from "@material-ui/icons/HomeRounded";
import useStyles from "../styles/permissionStyle";
import { useTranslation } from "../langs/useTranslation";
import { getHasPermissionEntry } from "@/config/drawerListItems";

const NoPermission = () => {
  const { t } = useTranslation("permission");
  const classes = useStyles();
  const history = useHistory();

  const handleRediect = () => {
    history.push(getHasPermissionEntry());
  };

  return (
    <div className={classes.root}>
      <main className={classes.content}>
        <div className={classes.noPermissionTitleSection}>
          <Typography variant="h4">{t("permission.oops")}</Typography>
          <Typography variant="h6">
            {t("permission.needPermissionText")}
          </Typography>
        </div>
        {/* <NavLink to="/"> */}
        <Button startIcon={<HomeRoundedIcon />} onClick={handleRediect}>
          {t("btn.backToHome")}
        </Button>
        {/* </NavLink> */}
      </main>
    </div>
  );
};

export default NoPermission;
